import { useAuth } from "../../utils/AuthContext";
import Skeleton from "react-loading-skeleton";
import AdminDashboard from "../Admin/Dashboard";
import PatientDashboard from "./PatientDashboard";
import PharmacistDashboard from "./PharmacistDashboard";
import PathologistDashboard from "./PathologistDashboard";
import NicuDashboard from "./NicuDashboard";
import HospitalDashboard from "./HospitalOfficeDashboard";
import DoctorDashboard from "./DoctorDashboard";

const DashboardHome = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="p-4">
        <Skeleton count={10} />
      </div>
    );
  }

  switch (user?.role) {
    case "user":
    case "patient":
      return <PatientDashboard />;
      
    case "pharmacist":
      return <PharmacistDashboard/>;

    case "pathologist":
      return <PathologistDashboard />;

    case "nicu_in_charge":
      return <NicuDashboard />;

    case "hospital_manager":
      return <HospitalDashboard/>;
    
    case "doctor":
      return <DoctorDashboard/>;

    default:
      return <AdminDashboard />;
  }
};

export default DashboardHome;